import { render, staticRenderFns } from "./ReviewListRow.vue?vue&type=template&id=e5c28a2e&scoped=true&"
import script from "./ReviewListRow.vue?vue&type=script&lang=js&"
export * from "./ReviewListRow.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListRow.vue?vue&type=style&index=0&id=e5c28a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c28a2e",
  null
  
)

export default component.exports